import { ISkeletonData, Spine } from "pixi-spine";
import * as PIXI from "pixi.js";
import { Container, DisplayObject } from "pixi.js";
import { CreateSpineResources, Filter, Geometry, HorizontalAlign, Log, Point, Rect, Safe, Size, VerticalAlign } from ".././MyHelpers";
import { ExpandingWildReelConfiguration, ExpandingWildReelResult, PlayWindow } from "../api";
import { AudioManager, Track } from "../AudioManager";
import { ISystemContext } from "../Context/SystemContext";
import { AtlasResource } from "../ResourceManager/AtlasResource";
import { JSONResource } from "../ResourceManager/JSONResource";
import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager } from "../ResourceManager/ResourceManager";
import { SpriteResource } from "../ResourceManager/SpriteResource";
import { Settings } from "../Settings";
import { ZIndex } from "../ZIndex";
import { ExpandingWildPosition } from "./ExpandingWildBulk";
import { ExpandingWildsReelFinishedCallback, ExpandingWildsReelNextWildCallback, ExpandingWildsReelParam } from "./ExpandingWildReel";
import { SlotFeaturePIXI } from "./SlotFeature";
import { SlotSymbol } from "./SlotSymbol";
import { ReelSetMapper, ReelSetMapperOverlay } from "./SpinAnimation/ReelSetMapper";
import { SymbolTypeAnim } from "./SpineSymbols/SymbolsCollection";
import { IInterval } from "../Context/Interval";


export class ExpandingWildReelPIXIAPP
{
	// size and position of this expanding wild
	//private rect: PixelRect = null;

	// size of the wild, in symbol unites
	public symbolsRect: Rect = null;

	private wildIndex: number
	private expandingWildSymbolIndex: number;

	private reelSetMapper: ReelSetMapper = null;

	//private sprite: CanvasSprite = null;

	protected animatedSprite : PIXI.AnimatedSprite = null;
	protected spine : Spine = null;
	protected containerPIXI : PIXI.Container = null;
	readonly textureSprites : PIXI.Texture [];
	readonly textureSpine : ISkeletonData;

	constructor(wildIndex: number, expandingWildSymbolIndex: number, symbolsRect: Rect, reelSetMapper: ReelSetMapper, textureSprites : PIXI.Texture [], textureSpine : ISkeletonData) {
		this.textureSprites = textureSprites;
		this.textureSpine = textureSpine;
		this.wildIndex = wildIndex;
		this.expandingWildSymbolIndex = expandingWildSymbolIndex;
		// this.sprite = sprite;
		this.symbolsRect = symbolsRect;
		this.reelSetMapper = reelSetMapper;

		// this.sprite.View().style.position = "absolute";
		// this.sprite.View().style.visibility = "hidden"; // default hidden
		// this.containerPIXI = new PIXI.Container();
		// if (animatedSprite != null) {
		// 	this.animatedSprite = animatedSprite;


		// 	this.animatedSprite.animationSpeed = 0.5;
		// 	this.animatedSprite.visible = false;
		// 	this.animatedSprite.loop = true;
		// 	this.animatedSprite.onComplete = () => {
		// 		this.Hide();
		// 	};
		// 	this.animatedSprite.onLoop = () => {
		// 		this.Hide();
		// 	}

		// 	this.containerPIXI.addChild(this.animatedSprite);
		// }

		// if (spine != null) {
		// 	this.spine = spine;
		// 	this.spine.visible = false;
		// 	this.containerPIXI.addChild(this.spine);
		// 	this.spine?.state?.addListener({
		// 		complete: () => {
		// 			this.Hide();
		// 		},
		// 	});
		// }
	}

	public SetRect(symbolsRect: Rect, pixelsRect: Rect): void {
		this.symbolsRect = symbolsRect;

		// this.sprite.SetSize(pixelsRect.Size());
		// this.sprite.View().style.left = pixelsRect.x + "px";
		// this.sprite.View().style.top = pixelsRect.y + "px";

		if (this.animatedSprite != null) {
			this.animatedSprite.width = pixelsRect.width;
			this.animatedSprite.height = pixelsRect.height;
			this.animatedSprite.position.set(pixelsRect.x, pixelsRect.y);
		}


		if (this.spine != null) {
			this.spine.width = pixelsRect.width;
			this.spine.height = pixelsRect.height;
			this.spine.position.set(pixelsRect.x, pixelsRect.y);
		}
	}

	public View(): HTMLElement {
		return null;
	}

    protected visible: boolean = false;

	public Show(): void {

       
        

		// TODO zoom in wild
		//this.sprite.View().style.visibility = "visible";
		//this.sprite.Restart(false);
		if(this.animatedSprite != null){
			this.animatedSprite.visible = true;
			// this.animatedSprite.gotoAndPlay(0);
			this.animatedSprite.play();
		}
		if(this.spine != null){
			this.spine.visible=true;
			this.spine?.state.setAnimation(0,"winSymbol",false);
		}

		// after wild is shown, replace symbols in the background on reels to the wild symbols
		this.Apply();

        if (this.visible)
        {
            return;
        }
		this.visible = true;

		this.onShowCallback?.(this.wildIndex);
	}

	public Apply(): void
	{
		this.reelSetMapper.AddOverlay(new ReelSetMapperOverlay(this.symbolsRect, this.expandingWildSymbolIndex));
	}

	public Hide(): void {

		//this.sprite.View().style.visibility = "hidden";
		//this.sprite.Stop();
		if (this.animatedSprite != null) {
			this.animatedSprite.stop();
			this.animatedSprite.visible = false;
		}
		if (this.spine != null) {
			this.spine.visible = false;
		}

		if (!this.visible) {
			return;
		}

        this.visible = false;
        this.onHideCallback?.(this.wildIndex);
	}

	public Update(): void {
		// this.sprite.Update();
	}

    public onShowCallback: ((wildIndex: number) => void) = null;
    public onHideCallback: ((wildIndex: number) => void) = null;
	public ViewPIXIAPP(){
		return this.containerPIXI;
	}
	
	public Create() {
		this.containerPIXI = new PIXI.Container();		
		if (this.textureSprites.length > 0) {
			this.animatedSprite = new PIXI.AnimatedSprite(this.textureSprites);


			this.animatedSprite.animationSpeed = 0.5;
			this.animatedSprite.visible = false;
			this.animatedSprite.loop = true;
			this.animatedSprite.onComplete = () => {
				this.Hide();
			};
			this.animatedSprite.onLoop = () => {
				this.Hide();
			}

			this.containerPIXI.addChild(this.animatedSprite);
		}

		if (this.textureSpine != null) {
			this.spine = new Spine(this.textureSpine);
			this.spine.visible = false;
			this.containerPIXI.addChild(this.spine);
			this.spine?.state?.addListener({
				complete: () => {
					this.Hide();
				},
			});
		}
	}

	public Destroy(){
		this.spine?.destroy({children: false, texture: false, baseTexture: true});
		this.animatedSprite?.destroy({children: false, texture: false, baseTexture: true});
		this.containerPIXI?.destroy({children: false, texture: true, baseTexture: true});		
	}
}
export class ExpandingWildsReelPIXIAPP extends SlotFeaturePIXI implements Resourceful
{
	public override CreatePIXIAPP(){
		this.viewPIXIAPP = new PIXI.Container();
		this.viewPIXIAPP.name = "ExpandingWildsReelPIXIAPP";
		this.viewPIXIAPP.width = Settings.ScreenWidth;
		this.viewPIXIAPP.height = Settings.ScreenHeight;
		//this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1);
	}
	
	protected params: ExpandingWildsReelParam = null;

	// size of slot window, in pixels
	private slotWindow: Rect = null;

	// size of slot window, in symbols
	private slotWindowSymbolSize: PlayWindow = null;

	// size of single symbol, in pixels
	private symbolSize: Size = null;

	//private sprite: Sprite = null;
	//private canvas: MyCanvas = null;
	private view: HTMLElement = null;

	private currentWild: number = -1;
	//private timer: number = 0;

	private reelSetMapper: ReelSetMapper = null;
    private symbol: SlotSymbol = null;

	private audio: AudioManager = null;

	private systemContext: ISystemContext;

	private nextWildDelay: IInterval;

	protected viewPIXIAPP : PIXI.Container = null;

	public constructor(param: ExpandingWildsReelParam, config: ExpandingWildReelConfiguration) {
		super(param.logGroup, param.resid, "ExpandingWildsReel", param.resourcesBasePath);

		this.params = param;
		this.gameName = param.gameName;

		this.symbol = param.availableSymbols.find(s => s.ID == config.Symbol);

        if (!this.symbol)
            throw `No required symbol ${config.Symbol}`;
		this.slotWindow = param.slotWindow;
		this.slotWindowSymbolSize = param.slotWindowSymbolSize;
		this.reelSetMapper = param.reelSetMapper;

		if (this.reelSetMapper == null) {
			Log.Error(this.logGroup, "ReelSetMapper should not be null");
			debugger;
		}

		this.symbolSize = new Size(this.slotWindow.width / this.slotWindowSymbolSize.Width, this.slotWindow.height / this.slotWindowSymbolSize.Height);

		this.audio = param.audio;

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.style.zIndex=ZIndex.WildBulkReel.toString();

		this.systemContext = param.systemContext.CreateSubContext("ExpandingWildsBulk");

		this.nextWildDelay = this.systemContext.TimingContext().CreateInterval("nextWildeDlay", 2000, () => {
			this.wilds[this.currentWild].Hide();
		});

		// this.viewPIXIAPP = new PIXI.Container();
		// this.viewPIXIAPP.name = "ExpandingWildsReelPIXIAPP";
		// this.viewPIXIAPP.width = Settings.ScreenWidth;
		// this.viewPIXIAPP.height = Settings.ScreenHeight;
		// this.viewPIXIAPP.y = Settings.ScreenHeight * (Settings.Screens - 1);
		
	}

	public wilds: ExpandingWildReelPIXIAPP[] = [];
	//private lastResult: ExpandingWildReelResult = null;
	private lastResultReels: number[] = [];

	public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {		
		this.audio.AddTrack(new Track(this.resourcesBasePath + "background" + Settings.audioFormat, this.resid.ScopedResourceName("background")));
		this.PrepareResourcesSpine(resourceManager);
		this.PrepareResourcesSprite(resourceManager);
	}

	protected PrepareResourcesSpine(resourceManager : IWriteOnlyResourceManager) {
		if(this.params.symbolTypeAnim == SymbolTypeAnim.Sprites) return;
		resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/${this.params.gameName}/resources/expanding_wild_reel/Spine/expanding_wild_reel.json`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-Feature-ExpandingWildReel-Json`)));
		resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/${this.params.gameName}/resources/expanding_wild_reel/Spine/expanding_wild_reel.atlas`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-Feature-ExpandingWildReel-Atlas`)));
	}

	protected PrepareResourcesSprite(resourceManager : IWriteOnlyResourceManager) {
		if(this.params.symbolTypeAnim == SymbolTypeAnim.Spine) return;
		// load sprite
		resourceManager.AddGlobal(new SpriteResource(this.resourcesBasePath + "expanding_wild_reel", ResourceIdentifier.Global.Add(this.params.gameName).Add("Feature").Add("ExpandingWildReel"), true, this.logGroup.Add("ExpandingWildReel"), true));
	}

	protected animatedSprite : PIXI.AnimatedSprite = null;
	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await this.ResourcesLoadedSymbolSpine(resourceManager);		
		await this.ResourcesLoadedSymbolSprite(resourceManager);
	}

	protected symbolRecTexture : Rect = null;
	protected pixiAssetSymbolReelWild : ISkeletonData  
	protected async ResourcesLoadedSymbolSpine(resourceManager: IReadOnlyResourceManager) {
		if(this.params.symbolTypeAnim == SymbolTypeAnim.Sprites) return;
		let symbolJsonResource = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-Feature-ExpandingWildReel-Json`));
		let pixiAssetSymbol = await PIXI.Assets.load(symbolJsonResource.path).finally(() => {
			PIXI.Assets.cache.remove(symbolJsonResource.path);
		});;
		this.pixiAssetSymbolReelWild = pixiAssetSymbol.spineData;
		let spine = await CreateSpineResources(pixiAssetSymbol.spineData);
		//spine.destroy();0'p;ojli8kjhtgr7 efn6svfbacwxAergszwececasd
		this.symbolRecTexture = new Rect(spine.x,spine.y,spine.width,spine.height);
	}

	protected expandingWildTexture : PIXI.Texture [] = [];
	protected async ResourcesLoadedSymbolSprite (resourceManager : IReadOnlyResourceManager){
		if(this.params.symbolTypeAnim == SymbolTypeAnim.Spine) return;
		let sprite = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add(this.params.gameName).Add("Feature").Add("ExpandingWildReel")).sprite;
		
		for (let decodedFrames of sprite.shared.decodedFrames) {
			//console.log(`Symbol_FrameDecode ${s.ID}`, decodedFrames);

			//console.log(`Symbol_FrameDecode ${s.ID}`, decodedFrames);
			let baseTexture = new PIXI.BaseTexture(new PIXI.ImageBitmapResource(decodedFrames));
			//baseTexture.scaleMode;
			//let scaleWidth = this.params.spinnableReels.GetSymbolSize().width / baseTexture.width;
			//let scaleHeight = this.params.spinnableReels.GetSymbolSize().height / baseTexture.height
			//let scale = Math.min(scaleWidth, scaleHeight);
			//baseTexture.width = baseTexture.width * scale;
			//baseTexture.height = baseTexture.height * scale
			// baseTexture.width = this.spinnableReels.GetSymbolSize().width;
			// baseTexture.height = this.spinnableReels.GetSymbolSize().height;
			let symbolTexture = new PIXI.Texture(baseTexture);


			this.expandingWildTexture.push(symbolTexture);			
		};

		this.animatedSprite = new PIXI.AnimatedSprite(this.expandingWildTexture);
		this.symbolRecTexture = new Rect(this.animatedSprite.x,this.animatedSprite.y,this.animatedSprite.width,this.animatedSprite.height);
		//this.animatedSprite.loop = false;	
		//this.animatedSprite.visible = false;
		this.animatedSprite.destroy();		
	}

	public Prepare(result: ExpandingWildReelResult): void 
	{
		//this.lastResult = result;
		//this.wilds = [];
		// create additional wilds

		this.lastResultReels = result.Positions.map(p => p.reel).filter(Filter.UniqueItem).sort();

		if (this.wilds.length < this.lastResultReels.length)
		{
			for (let i = this.wilds.length; i < this.lastResultReels.length; i++) {


				//let sprite: CanvasSprite = new CanvasSprite({sprite: this.sprite.Copy(), canvasSize: new Size(1, 1)});
				let wild: ExpandingWildReelPIXIAPP = new ExpandingWildReelPIXIAPP(i, this.symbol.Index, new Rect(0, 0, 1, 1), this.reelSetMapper,this.expandingWildTexture,this.pixiAssetSymbolReelWild);
				//wild.View().style.zIndex=ZIndex.WildBulk.toString();
				//wild.AddOnShowCallback((wildIndex: number) => this.OnWildShown(wildIndex));
                wild.onShowCallback = this.OnWildShown.bind(this);
                wild.onHideCallback = this.OnWildHidden.bind(this);

				this.wilds.push(wild);
				//this.view.appendChild(wild.View());				
			}
		}

		// wild expands to all neighbours
		for (let i = 0; i < this.lastResultReels.length; i++) {
			let reel = this.lastResultReels[i];
			let position: ExpandingWildPosition = {
				reel: reel,
				row: 0
			}

	        // let reel = position.reel;

	        let topSymbol = 0
	        let bottomSymbol = this.slotWindowSymbolSize.Height - 1;

			// include right and bottom symbols, they are covered
			let wildSymbolsRect = Rect.FromCoordiantes(reel, topSymbol, reel +1, bottomSymbol +1);

			let wildRect = new Rect(
				(wildSymbolsRect.x * this.symbolSize.Width) + this.slotWindow.x,
				(wildSymbolsRect.y * this.symbolSize.Height) + this.slotWindow.y,

				wildSymbolsRect.width * this.symbolSize.Width,
				wildSymbolsRect.height * this.symbolSize.Height
			);

			// calculate actual size, so that image covers the symbols that will change

			// remember center, wild zooms in from the center symbol, that triggered
			let centerSymbol = new Point(position.reel, position.row);
			// center, in pixels
			//let center = new Point((centerSymbol.x + 0.5) * this.symbolSize.width, (centerSymbol.y + 0.5) * this.symbolSize.height);

			let wild: ExpandingWildReelPIXIAPP = this.wilds[i];
			wild.Create();
			this.viewPIXIAPP.addChild(wild.ViewPIXIAPP());

			// calculate size of canvas, so that it covers whole area 
			let wildCoverRect = Geometry.CoverRect(new Rect(centerSymbol.x,centerSymbol.y,this.symbolRecTexture.width, this.symbolRecTexture.height), wildRect, HorizontalAlign.Center, VerticalAlign.Center);
			let wildCoverInflatedRect = wildCoverRect.Inflate(new Size(wildCoverRect.width * 0.1, wildCoverRect.height * 0.1));

			// set new position and size of the wild
			wild.SetRect(wildSymbolsRect, wildCoverInflatedRect);
		}
	}

	protected started: boolean = false;
	protected stopRequested: boolean = false;

	public get IsRunning(): boolean
	{
		return this.started;
	}

	public Start(): void 
	{
		if (!this.started)
		{
			this.started = true;
			this.stopRequested = false;

			this.currentWild = -1;
			this.nextWildDelay.Start();
			
			// start first wild right now
			this.NextWild();
		}
	}

	public RequestStop(): void
	{
		if (this.started)
		{
            this.started = false;

			if (!this.stopRequested)
			{
				Log.Error(this.logGroup, "Requesting stop!");
				this.stopRequested = true;
				// stop timer if running
				this.nextWildDelay.Stop();

				// hide current wild
				if (this.currentWild != -1) 
				{
					this.wilds[this.currentWild].Hide();

					// make sure to redraw sprites
					this.wilds[this.currentWild].Update();
				}

				// go fast trough remaining wilds
				for (this.currentWild++; this.currentWild <this.lastResultReels.length; this.currentWild++)
				{
					// only apply wild without showing it
					this.wilds[this.currentWild].Apply();

					this.wilds[this.currentWild].Update();

					// move to next
					this.OnNext(this.currentWild, this.wilds[this.currentWild].symbolsRect);
				}
				this.StopAudio();
				// reset current wild
				this.currentWild = -1;

				this.OnComplete();
			}
			else
			{
				Log.Error(this.logGroup, "Stop already requested!");
			}
		}
		else
		{
			Log.Error(this.logGroup, "Feature not started!");
		}
	}

	private OnWildShown(wildIndex: number)
    {
		//this.sprite.Restart(false);
		//this.animatedSprite.play();		
	}

    private OnWildHidden(wildIndex: number)
    {		
        this.NextWild();
    }

	private NextWild(): void
    {
        if (!this.started) return;

		if (this.currentWild >= this.lastResultReels.length -1) {

			// hide the last
			if (this.currentWild != -1) {
				this.wilds[this.currentWild].Hide();
			}
			
			// finished
			// Log.Debug(this.logGroup, "Wilds complete");

			this.nextWildDelay.Stop();
			this.started = false;
			this.stopRequested = false;
			this.OnComplete();
		}
		else
        {

			if (this.currentWild != -1) {
				// hide current wild
				this.wilds[this.currentWild].Hide();
			}

			this.currentWild++;

			// Log.Debug(this.logGroup, "Displaying wild " + this.currentWild + " of " + this.lastResult.Positions.length);


			this.wilds[this.currentWild].Show();

			// play audio - repeat up to 3 times depending on wild size
			//let wildArea: number = this.wilds[this.currentWild].symbolsRect.Area();
			//let repeats: number = 1;

			// Log.Debug(this.logGroup, "Expanding wild area " + wildArea + ", repeats " + repeats);

			this.audio.Play(this.resid.ScopedResourceName("background"));
			this.OnNext(this.currentWild, this.wilds[this.currentWild].symbolsRect);
		}
	}

	protected StopAudio(): void
	{
		// then also stop audio
		this.audio.Stop(this.resid.ScopedResourceName("background"));
	}

	public Update() {
		// if (this.currentWild != -1) {
		// 	this.wilds[this.currentWild].Update();
		// }
	}



	public View(): HTMLElement {
		return null;
	}

	private completeCallbaks: ExpandingWildsReelFinishedCallback[] = [];
	private OnComplete() {

        //// Log.Debug(this.logGroup, "OnComplete()")
		for (let callback of this.completeCallbaks) {
			callback();
		}
	}

	public AddOnCompleteCallback(callback: ExpandingWildsReelFinishedCallback) {
		this.completeCallbaks.push(callback);
	}

	private nextWildCallbacks: ExpandingWildsReelNextWildCallback[] = [];
	private OnNext(wildIndex: number, rect: Rect) {
		for (let callback of this.nextWildCallbacks) {
			callback(wildIndex, rect);
		}
	}

	// public AddOnNextCallback(callback: ExpandingWildsReelNextWildCallback) {
	// 	this.nextWildCallbacks.push(callback);
	// }

	public ViewPIXIAPP(): Container<DisplayObject> {
		return this.viewPIXIAPP;
	}

	public Destroy(){
		this.wilds.forEach(ele=>{
			ele.Destroy();
		})
		this.viewPIXIAPP.destroy({children: false, texture: true, baseTexture: true});
	}
}